<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
    <div class="card-header pb-0">
      <h6>Lista de tareas</h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">

        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">OPCIONES</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producción</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. recibida</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. entregada</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Cant. defectuosa</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha recibido</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha entregado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Fecha validado</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >observación</th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
              >Total ganancia</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="value in data" :key="value.id">
              <td class="align-middle text-center">
                <div style="display: flex;justify-content: center; align-items: center;gap: 10px;height: 100%;">
                  <a
                    @click="checkReceived(value)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    data-toggle="tooltip"
                    data-original-title="Recibir tarea"
                    v-if="value.received_date == null"
                  >
                    <i class="fa fa-arrow-down"></i>
                  </a>
                  <a
                    @click="checkDelivered(value)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    data-toggle="tooltip"
                    data-original-title="Entregar tarea"
                    v-if="value.received_date != null && value.delivered_date == null"
                  >
                    <i class="fa fa-arrow-up"></i>
                  </a>
                  <a
                    @click="checkValidated(value)"
                    class="text-secondary font-weight-bold text-xs cursor-pointer"
                    data-toggle="tooltip"
                    data-original-title="Validar tarea"
                    v-if="value.delivered_date != null && value.validated_date == null"
                  >
                    <i class="fa fa-check"></i>
                  </a>
                  <span style="color: forestgreen;" v-if="value.validated_date != null">
                    <i class="fa fa-check"></i>
                  </span>
                </div>
              </td>
              <td class="align-middle">
                <div class="text-secondary text-xs font-weight-bold">
                  Modelo: {{  value?.model?.model?.name  }}
                </div>
                <div class="text-secondary text-xs font-weight-bold">
                  Oficio: {{  value?.oficio?.name  }}
                </div>
                <div class="text-secondary text-xs font-weight-bold">
                  Talla: {{  value?.model?.size?.size  }}
                </div>
                <div class="text-secondary text-xs font-weight-bold">
                  Color: {{  value?.model?.size?.color?.name  }}
                </div>
              </td>
              <td class="align-middle text-center">
                {{ value?.received_quantity }}
              </td>
              <td class="align-middle text-center">
                {{ value?.delivered_quantity }}
              </td>
              <td class="align-middle text-center">
                {{ value?.rejected_quantity }}
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.received_date) ? new Date(value.received_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.delivered_date) ? new Date(value.delivered_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ isValidDate(value.validated_date) ? new Date(value.validated_date).toLocaleDateString('es-ES') : 'Sin asignar' }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                {{ value.observation }}
                </span>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                {{ parseFloat(value.total).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                </span>
              </td>
            </tr>
           
          </tbody>
        </table>

        <div class="pagination p-3">
          <!-- Recorremos los links para generar los botones -->
          <a 
            v-for="link in links" 
            :key="link.label" 
            class="page-item cursor-pointer" 
            @click="fetchData(link.url)" 
            :disabled="!link.url || link.active" 
            :class="{ 'active': link.label === currentPage.toString() }"
          >
            {{ link.label }}
          </a>
        </div>

      </div>

    
    </div>
  </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';

export default {
  name: 'OperadorTasks',
  data() {
    return {
      oficios: [],
      users: [],
    };
  },
  computed: {
    ...mapGetters('productionUsers', ['allData','currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
        return this.$store.state.productionUsers.currentPage;
    },
    lastPage() {
        return this.$store.state.productionUsers.lastPage;
    },
    data() {
        return this.allData || [];
    },
    links() {
      return this.$store.getters['productionUsers/links'];
    },
  },
  methods: {
    async fetchData(pageUrl = null) {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (!user) {
          return;
        }

        const params = {
          user_id: user.id,
          page: pageUrl ? new window.URL(pageUrl).searchParams.get('page') || 1 : 1,
        };

        await this.$store.dispatch('productionUsers/fetchData', params);
      } catch (error) {
        console.error('Error al cargar tareas:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al cargar las tareas',
        });
      }
    },
    isValidDate(date) {
      // Verifica si el valor es nulo, indefinido o vacío
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Recibir Tarea',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const updatedValue = { ...value };
          updatedValue.received_date = new Date().toISOString().slice(0, 10);

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Tarea aceptada!',
              'Recuerda realizar la entrega.',
              'success'
            );

            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async checkDelivered(value) {
      const updatedValue = { ...value };

      try {
        let cantt = Number(updatedValue.received_quantity) - Number(updatedValue.delivered_quantity || 0);

        const { value: formValues } = await Swal.fire({
          title: 'Entregar Tarea',
          html: `
          <div style="text-align: left;">
          <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Si entregas una cantidad menor a la recibida, tendras que volver a realizar la entrega del restante</label>
              </div>
              <div class="mb-3" hidden>
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Cantidad entregada:</label>
                <input id="swal-input-cant" type="number" class="form-control" placeholder="Cantidad entregada" min="1" value="${cantt}">
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          preConfirm: () => {
            const cant = document.getElementById('swal-input-cant').value;
            const obs = document.getElementById('swal-input-obs').value;

            return { cant: parseInt(cant, 10), obs };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar!',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
          updatedValue.delivered_quantity = formValues.cant;
          updatedValue.observation = formValues.obs;

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea Entregada!',
              'Excelente trabajo.',
              'success'
            );
            this.fetchData();
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async getOficios() {
      try {
        const response = await this.$store.dispatch('oficios/getOficios');
        this.oficios = response?.data || [];
      } catch (error) {
        console.error('Error al cargar oficios:', error);
        this.oficios = [];
      }
    },
    async getUsers() {
      try {
        this.users = await this.$store.dispatch('users/getAll', 'all');
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
        this.users = [];
      }
    },
    async checkValidated(value) {
      try {
        // Asegurarse de que oficios y usuarios estén cargados
        if (!this.oficios || this.oficios.length === 0) {
          await this.getOficios();
        }
        if (!this.users || this.users.length === 0) {
          await this.getUsers();
        }

        const { value: formValues } = await Swal.fire({
          title: 'Validar Tarea',
          html: `
            <div style="text-align: left;">
              <!-- Defectos -->
              <div class="mb-3">
                <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos (Imperfectos):</label>
                <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0">
              </div>

              <!-- Opciones exclusivas -->
              <div class="mb-3">
                <input type="checkbox" id="swal-check-corte">
                <label class="form-check-label" for="swal-check-corte">Piezas / Cortes</label>
              </div>

              <div class="mb-3">
                <input type="checkbox" id="swal-check-arreglos">
                <label class="form-check-label" for="swal-check-arreglos">Arreglos Modistas</label>
              </div>

              <div class="mb-3">
                <input type="checkbox" id="swal-check-lavanderia">
                <label class="form-check-label" for="swal-check-lavanderia">Lavandería</label>
              </div>

              <!-- Sección Corte -->
              <div id="swal-corte-section" style="display:none;">
                <!-- Select de Oficio para nueva tarea -->
                <div class="mb-3" id="swal-oficio-section" style="display: none;">
                  <label for="swal-select-oficio" class="form-label" style="font-weight: bold;">Oficio para nueva tarea (opcional):</label>
                  <select id="swal-select-oficio" class="form-control">
                    <option value="">Seleccionar oficio</option>
                    ${this.oficios.map(o => `<option value="${o.id}">${o.name}</option>`).join("")}
                  </select>
                </div>
                <div class="mb-3">
                  <label for="swal-user-corte" class="form-label" style="font-weight: bold;">Usuario corte:</label>
                  <select id="swal-user-corte" class="form-control">
                    <option value="">Seleccionar usuario</option>
                    ${this.users.map(u => `<option value="${u.id}">${u.name}</option>`).join("")}
                  </select>
                </div>
                <div class="mb-3">
                  <label for="swal-cant-corte" class="form-label" style="font-weight: bold;">Cantidad corte:</label>
                  <input id="swal-cant-corte" type="number" class="form-control" placeholder="Cantidad" min="0">
                </div>
              </div>

              
              <!-- Sección Arreglos -->
              <div id="swal-arreglos-section" style="display:none;">
                <!-- Select de Oficio para nueva tarea -->
                <div class="mb-3" id="swal-oficio-arreglos-section" style="display: none;">
                  <label for="swal-select-oficio-arreglos" class="form-label" style="font-weight: bold;">Oficio para nueva tarea (opcional):</label>
                  <select id="swal-select-oficio-arreglos" class="form-control">
                    <option value="">Seleccionar oficio</option>
                    ${this.oficios.map(o => `<option value="${o.id}">${o.name}</option>`).join("")}
                  </select>
                </div>
                <div class="mb-3">
                  <label for="swal-user-arreglos" class="form-label" style="font-weight: bold;">Usuario Modista:</label>
                  <select id="swal-user-arreglos" class="form-control">
                    <option value="">Seleccionar usuario</option>
                    ${this.users.map(u => `<option value="${u.id}">${u.name}</option>`).join("")}
                  </select>
                </div>
                <div class="mb-3">
                  <label for="swal-cant-arreglos" class="form-label" style="font-weight: bold;">Cantidad a arreglar:</label>
                  <input id="swal-cant-arreglos" type="number" class="form-control" placeholder="Cantidad" min="0">
                </div>
              </div>

              <!-- Sección Lavandería -->
              <div id="swal-lavanderia-section" style="display:none;">
                <div class="mb-3">
                  <label for="swal-observacion-lavanderia" class="form-label" style="font-weight: bold;">Observación:</label>
                  <textarea id="swal-observacion-lavanderia" class="form-control" rows="3" placeholder="Agregar observación"></textarea>
                </div>
              </div>

            </div>
          `,
          didOpen: () => {
            const defectInput = document.getElementById('swal-input-defect');
            const oficioSection = document.getElementById('swal-oficio-section');
            const oficioArreglosSection = document.getElementById('swal-oficio-arreglos-section');
            const checkCorte = document.getElementById("swal-check-corte");
            const checkLav = document.getElementById("swal-check-lavanderia");
            const checkArr = document.getElementById("swal-check-arreglos");

            const corteSection = document.getElementById("swal-corte-section");
            const lavSection = document.getElementById("swal-lavanderia-section");
            const arrSection = document.getElementById("swal-arreglos-section");

            // Función para actualizar la visibilidad del select de oficio
            const updateOficioVisibility = () => {
              const cant = Number(defectInput.value) || 0;
              const corteVisible = checkCorte.checked;
              const arreglosVisible = checkArr.checked;
              
              // Mostrar en sección de corte si hay defectuosos Y corte está seleccionado
              if (cant > 0 && corteVisible) {
                oficioSection.style.display = 'block';
              } else {
                oficioSection.style.display = 'none';
              }
              
              // Mostrar en sección de arreglos si hay defectuosos Y arreglos está seleccionado
              if (cant > 0 && arreglosVisible) {
                oficioArreglosSection.style.display = 'block';
              } else {
                oficioArreglosSection.style.display = 'none';
              }
            };

            // Mostrar select de oficio cuando hay defectuosos y la sección correspondiente está seleccionada
            defectInput.addEventListener('input', updateOficioVisibility);

            // Solo permitir un check activo a la vez
            const allChecks = [checkCorte, checkLav, checkArr];
            allChecks.forEach(chk => {
              chk.addEventListener("change", () => {
                if (chk.checked) {
                  allChecks.forEach(c => { if (c !== chk) c.checked = false; });
                }
                corteSection.style.display = checkCorte.checked ? "block" : "none";
                lavSection.style.display = checkLav.checked ? "block" : "none";
                arrSection.style.display = checkArr.checked ? "block" : "none";
                // Actualizar visibilidad del select de oficio cuando cambia el checkbox
                updateOficioVisibility();
              });
            });
          },
          focusConfirm: false,
          preConfirm: () => {
            const defectInput = document.getElementById('swal-input-defect').value;
            const oficioSelectElement = document.getElementById('swal-select-oficio');
            const oficioSelectArreglosElement = document.getElementById('swal-select-oficio-arreglos');
            const oficioSelect = oficioSelectElement ? oficioSelectElement.value : '';
            const oficioSelectArreglos = oficioSelectArreglosElement ? oficioSelectArreglosElement.value : '';

            const checkCorte = document.getElementById('swal-check-corte').checked;
            const checkLav = document.getElementById('swal-check-lavanderia').checked;
            const checkArr = document.getElementById('swal-check-arreglos').checked;

            const userCorte = document.getElementById('swal-user-corte').value;
            const cantCorte = document.getElementById('swal-cant-corte').value;

            const obsLav = document.getElementById('swal-observacion-lavanderia').value;

            const userArr = document.getElementById('swal-user-arreglos').value;
            const cantArr = document.getElementById('swal-cant-arreglos').value;

            if (defectInput === '' || isNaN(defectInput)) {
              Swal.showValidationMessage('Debe ingresar una cantidad válida de defectos.');
              return false;
            }
            const cant = Number(defectInput);
            if (cant > Number(value.received_quantity)) {
              Swal.showValidationMessage('La cantidad con defectos supera la asignada.');
              return false;
            }

            let selected_option = null;
            let corte = null, lavanderia = null, arreglos = null;

            if (checkCorte) {
              selected_option = 'cut';
              if (!userCorte) {
                Swal.showValidationMessage('Debe seleccionar un usuario de corte.');
                return false;
              }
              if (cantCorte === '' || isNaN(cantCorte) || Number(cantCorte) <= 0) {
                Swal.showValidationMessage('Debe ingresar una cantidad válida de corte.');
                return false;
              }
              corte = { user_id: userCorte, cantidad: Number(cantCorte), observacion: obsLav.trim() };
            } 
            else if (checkLav) {
              selected_option = 'laundry';
              if (obsLav.trim() === '') {
                Swal.showValidationMessage('Debe ingresar una observación para Lavandería.');
                return false;
              }
              lavanderia = { observacion: obsLav.trim() };
            } 
            else if (checkArr) {
              selected_option = 'fixes';
              if (!userArr) {
                Swal.showValidationMessage('Debe seleccionar un usuario modista.');
                return false;
              }
              if (cantArr === '' || isNaN(cantArr) || Number(cantArr) <= 0) {
                Swal.showValidationMessage('Debe ingresar una cantidad válida para arreglos.');
                return false;
              }
              arreglos = { user_id: userArr, cantidad: Number(cantArr), observacion: obsLav.trim() };
            }

            // Obtener el oficio seleccionado (puede ser de corte o arreglos)
            let oficioId = null;
            if (checkCorte && oficioSelect) {
              oficioId = parseInt(oficioSelect);
            } else if (checkArr && oficioSelectArreglos) {
              oficioId = parseInt(oficioSelectArreglos);
            } else {
              // Si no hay uno específico, intentar con cualquiera que tenga valor
              oficioId = (oficioSelect || oficioSelectArreglos) ? parseInt(oficioSelect || oficioSelectArreglos) : null;
            }
            
            return { 
              defectos: cant, 
              selected_option, 
              corte, 
              lavanderia, 
              arreglos,
              oficio_id: oficioId
            };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          // CREAR NUEVA TAREA ANTES DE VALIDAR LA TAREA ACTUAL
          if ((formValues.corte || formValues.arreglos) && formValues.oficio_id) {
            try {
              // Fecha de asignación: fecha actual del día
              const today = new Date().toISOString().slice(0, 10);
              
              let newTask = {
                id: 0,
                production_id: value.production_id,
                production_models_id: value.production_models_id,
                oficio_id: formValues.oficio_id,
                status: 0,
                assigned_at: today,
              };

              // Si es corte
              if (formValues.corte) {
                newTask.user_id = formValues.corte.user_id;
                newTask.received_quantity = formValues.corte.cantidad;
                newTask.observation = formValues.corte.observacion || `Tarea creada automáticamente desde defectuosos de tarea #${value.id} - Corte`;
              }
              // Si es arreglos
              else if (formValues.arreglos) {
                newTask.user_id = formValues.arreglos.user_id;
                newTask.received_quantity = formValues.arreglos.cantidad;
                newTask.observation = formValues.arreglos.observacion || `Tarea creada automáticamente desde defectuosos de tarea #${value.id} - Arreglos`;
              }
              
              const newTaskResponse = await this.$store.dispatch("productionUsers/save", newTask);
              
              if (newTaskResponse && newTaskResponse.status >= 200 && newTaskResponse.status < 300) {
                console.log('Nueva tarea creada exitosamente');
              } else {
                throw new Error('Error al crear la nueva tarea');
              }
            } catch (error) {
              console.error("Error al crear nueva tarea:", error);
              await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al crear la nueva tarea: ' + (error.message || 'Error desconocido') + '. La tarea no se validará.',
              });
              return; // No continuar con la validación si falla la creación de la nueva tarea
            }
          }

          // AHORA SÍ VALIDAR LA TAREA ACTUAL
          const updatedValue = {
            ...value,
            validated_date: new Date().toISOString().slice(0, 10),
            rejected_quantity: formValues.defectos,
            finish: 1,
            selected_option: formValues.selected_option,
          };

          if (formValues.corte) {
            Object.assign(updatedValue, {
              corte_user_id: formValues.corte.user_id,
              corte_cantidad: formValues.corte.cantidad,
              laundry_observation: formValues.corte.observacion
            });
          }

          if (formValues.lavanderia) {
            Object.assign(updatedValue, {
              laundry_observation: formValues.lavanderia.observacion
            });
          }

          if (formValues.arreglos) {
            Object.assign(updatedValue, {
              arreglo_user_id: formValues.arreglos.user_id,
              arreglo_cantidad: formValues.arreglos.cantidad,
              laundry_observation: formValues.arreglos.observacion,
            });
          }

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);
          if (response && response.status >= 200 && response.status < 300) {
            // Mensaje de éxito
            let successMessage = 'Excelente trabajo.';
            if (formValues.corte || formValues.arreglos) {
              if (formValues.oficio_id) {
                successMessage = 'Tarea validada y nueva tarea creada.';
              } else {
                successMessage = 'Tarea validada.';
              }
            } else if (formValues.lavanderia) {
              successMessage = 'Tarea validada. Observación de lavandería guardada.';
            }

            await Swal.fire('Tarea Validada!', successMessage, 'success');
            this.fetchData();
          } else {
            throw new Error(response.data?.message || 'Error al validar la tarea');
          }
        }
      } catch (error) {
        console.error("Error al validar la tarea:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al validar la tarea',
        });
      }
    },
  },
  mounted() {
    this.fetchData(); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold; /* Estilo para la página activa */
}
</style>